export default `
<section>
  <p>You are only allowed to fill the application if you have the right to represent the provider company.
  </p>
  <p>The InnoCAPE consortium is not responsible for the correctness of information given in the application.
  </p>
  <p>Applications from within the EU are handled by an assigned regional partners or by coordinator otherwise. InnoCAPE
    consortium will determine which providers will be included in the Competence Map database. The consortium reserves
    the right to decline the application or remove previously approved provider from the listings either temporarily or
    permanently based on feedback or an audit. Any edits after the submission will be done by the assigned regional
    partners on request from the provider, to correct information confirmed from trusted source or to make content
    appear better on the service.
  </p>
  <p>The InnoCAPE consortium does not charge the provider for the application process or having presence (being listed)
    on the Competence Map but also does not give any guarantee of how much visibility the system gives for the provider.
    All this is driven by the search terms used by the users and the search algorithm. The system will send monthly
    report for provider on achieved visibility.
  </p>
  <p>The InnoCAPE consortium reserves the right to use the system, provider and usage data for reporting and analysis of
    digitalization status and needs.
  </p>
  <p>If you have any questions about the Compentence Map, application process or related, please contact your nearest
    <a target="_blank" href="https://dma.innocape.eu/en/contacts" rel="noopener noreferrer">project partner
    </a> for more information.
  </p>
</section>
`
